define('OutSystems/ClientRuntime/modules/PersistentKeyValue/PersistentKeyValueStorage',["require", "exports", "tslib", "../../Logger", "./PersistentKeyValueInitializer", "./PersistentKeyValueTableInfo"], function (require, exports, tslib_1, Logger, PersistentKeyValueInitializer_1, PersistentKeyValueTableInfo_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PersistentKeyValueStorage = (function () {
        function PersistentKeyValueStorage(db) {
            this.db = db;
            this.ready = false;
            Logger.trace(this, "Registering initializer for entity persistent key value info table.");
            db.registerInitializer(PersistentKeyValueInitializer_1.default);
        }
        PersistentKeyValueStorage.prototype.isReady = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var _a;
                var _this = this;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!!this.ready) return [3, 2];
                            _a = this;
                            return [4, this.db.executeReadTransaction(function (tx) { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
                                    return [2, tx.existsTable(PersistentKeyValueTableInfo_1.default)];
                                }); }); })];
                        case 1:
                            _a.ready = _b.sent();
                            _b.label = 2;
                        case 2: return [2, this.ready];
                    }
                });
            });
        };
        PersistentKeyValueStorage.prototype.setValue = function (key, value) {
            var _this = this;
            return this.db.executeTransaction(function (tx) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var newRecord;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            newRecord = { KEY: key, VALUE: value };
                            return [4, tx.upsertRecord(PersistentKeyValueTableInfo_1.default, newRecord)];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            }); });
        };
        PersistentKeyValueStorage.prototype.getValue = function (key) {
            var _this = this;
            return this.db.executeReadTransaction(function (tx) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var record;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, tx.getRecord(PersistentKeyValueTableInfo_1.default, key)];
                        case 1:
                            record = _a.sent();
                            return [2, record === null || record === void 0 ? void 0 : record.VALUE];
                    }
                });
            }); });
        };
        return PersistentKeyValueStorage;
    }());
    exports.default = PersistentKeyValueStorage;
});
//# sourceMappingURL=PersistentKeyValueStorage.js.map;
